import { Box, Modal } from "@mui/material"
import Appointments from "../Estimate/Appointments"

const AppointmentModal = ({
    openAppointments,
    handleCloseAppointments,
    storeId,
    store,
}) => {
    return (
        <Modal
            open={openAppointments}
            onClose={handleCloseAppointments}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box>
                <Appointments
                    open={openAppointments}
                    handleClose={handleCloseAppointments}
                    location={{ data: store || { storeId } }}
                    endpoint="/maaco/sch"
                />
            </Box>
        </Modal>
    )
}

export default AppointmentModal
